import { LOCALE } from '@/helpers/locale'
import { forceReload } from '@/helpers'
import i18n from '@/i18n'

const state = {
  locale: i18n.locale
}

const mutations = {
  SET_LOCALE (state, data) {
    state.locale = data
  }
}

const actions = {
  setLocale ({ commit }, data) {
    commit('SET_LOCALE', data)
    i18n.locale = data
    document.documentElement.setAttribute('lang', LOCALE[data].iso)
    forceReload()
  }
}

const getters = {
  getLocaleCode: (state) => LOCALE[state.locale].code,
  getLocaleIso: (state) => LOCALE[state.locale].iso,
  getLocaleServiceLanguageCode: (state) => LOCALE[state.locale].serviceLanguageCode,
  getLocalizedAlgoliaIndexName: (state) => (indexName) => {
    const suffix = LOCALE[state.locale].algoliaSuffix
    return suffix ? `${indexName}_${suffix}` : indexName
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
